import { render, staticRenderFns } from "./SectorSetup.vue?vue&type=template&id=5842daa0&"
import script from "./SectorSetup.vue?vue&type=script&lang=js&"
export * from "./SectorSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports